// import Robots from '@System/views/robots'
// import NotifyConfigs from '@System/views/notifyconfig'
// import NotifyConfigCreate from '@System/views/notifyconfig/create'
// import MailConfig from '@System/views/mail-config'
// import Notification from '@System/views/notification'
// import Contact from '@System/views/contact'
// import NotifyTopic from '@System/views/notify-topic'

import Layout from '@/layouts/RouterView'
import { hasServices } from '@/utils/auth'
import store from '@/store'
import i18n from '@/locales'
import { isScopedPolicyMenuHidden } from '@/utils/scopedPolicy'

const DictionarySetting = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/dictionary-setting')
const GlobalSetting = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/global-setting')
const Endpoint = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/endpoint')
const Notice = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/notice')
const CompanyInfo = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/companyinfo')
const Strategyallocation = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/strategyallocation')
const Strategydefinition = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/strategydefinition')
const StrategydefinitionCreate = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/strategydefinition/create')
const Tag = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@Cloudenv/views/tag')
const Inspection = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/inspection')
const Service = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/service')
const PreDefinedTag = () => import(/* webpackChunkName: "system" */ /* webpackPrefetch: true */ '@System/views/pre-defined-tag')

export default {
  index: 99,
  meta: {
    label: () => process.env.VUE_APP_PLATFORM === 'operation' ? i18n.t('system.text_1') : i18n.t('dictionary.menu_system_config'),
    t: 'dictionary.menu_system_config',
    icon: 'menu-setting',
  },
  menus: [
    {
      meta: {
        label: i18n.t('inspection.menu.group.inspect'),
      },
      subGroup: 'system',
      submenus: [
        {
          path: '/inspection',
          component: Layout,
          meta: {
            label: i18n.t('inspection.menu.env_inspection'),
            permission: 'check_list',
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.inspection')) {
                return true
              }
              return !hasServices('autoupdate') || !store.getters.isAdminMode || store.getters.isSysCE
            },
          },
          children: [
            {
              name: 'Inspection',
              path: '',
              component: Inspection,
            },
          ],
        },
      ],
    },
    // {
    //   meta: {
    //     label: i18n.t('system.text_564'),
    //   },
    //   submenus: [
    //     {
    //       path: '/notification',
    //       meta: {
    //         label: i18n.t('system.text_16'),
    //         permission: 'notifications_list',
    //         hidden: () => {
    //           if (isScopedPolicyMenuHidden('sub_hidden_menus.notification')) {
    //             return true
    //           }
    //           return !hasServices('notify')
    //         },
    //         t: 'dictionary.webconsole',
    //       },
    //       component: Layout,
    //       children: [
    //         {
    //           name: 'Notification',
    //           path: '',
    //           component: Notification,
    //         },
    //       ],
    //     },
    //     {
    //       path: '/notify-topic',
    //       meta: {
    //         label: i18n.t('system.text_16'),
    //         permission: 'topics_list',
    //         hidden: () => {
    //           if (isScopedPolicyMenuHidden('sub_hidden_menus.notify-topic')) {
    //             return true
    //           }
    //           if (!(store.getters.isAdminMode || store.getters.isDomainMode)) {
    //             return true
    //           }
    //           return !hasServices('notify')
    //         },
    //         t: 'dictionary.notify-topic',
    //       },
    //       component: Layout,
    //       children: [
    //         {
    //           name: 'NotifyTopic',
    //           path: '',
    //           component: NotifyTopic,
    //         },
    //       ],
    //     },
    //     {
    //       path: '/mailconfig',
    //       meta: {
    //         label: i18n.t('system.text_19'),
    //         permission: 'configs_list',
    //         hidden: () => {
    //           return true
    //         },
    //       },
    //       component: Layout,
    //       children: [
    //         {
    //           name: 'MailConfig',
    //           path: '',
    //           component: MailConfig,
    //         },
    //       ],
    //     },
    //     {
    //       path: '/notifyconfig',
    //       meta: {
    //         label: i18n.t('system.text_19'),
    //         hidden: () => {
    //           if (isScopedPolicyMenuHidden('sub_hidden_menus.mailconfig')) {
    //             return true
    //           }
    //           return !hasServices('notify')
    //         },
    //       },
    //       component: Layout,
    //       children: [
    //         {
    //           name: 'NotifyConfig',
    //           path: '',
    //           component: NotifyConfigs,
    //         },
    //         {
    //           name: 'NotifyConfigCreate',
    //           path: 'create',
    //           component: NotifyConfigCreate,
    //         },
    //       ],
    //     },
    //     {
    //       path: '/contact',
    //       meta: {
    //         label: i18n.t('common_27'),
    //         permission: 'contacts_list',
    //         hidden: () => {
    //           if (isScopedPolicyMenuHidden('sub_hidden_menus.contact')) {
    //             return true
    //           }
    //           return !store.getters.isAdminMode && !store.getters.isDomainMode
    //         },
    //       },
    //       component: Layout,
    //       children: [
    //         {
    //           name: 'Contact',
    //           path: '',
    //           component: Contact,
    //         },
    //       ],
    //     },
    //     {
    //       path: '/robot',
    //       meta: {
    //         label: i18n.t('system.robot_manage'),
    //       },
    //       component: Layout,
    //       children: [
    //         {
    //           name: 'Robots',
    //           path: '',
    //           component: Robots,
    //         },
    //       ],
    //     },
    //   ],
    // },
    {
      meta: {
        label: i18n.t('system.text_15'),
      },
      subGroup: 'system',
      submenus: [
        {
          path: '/notice',
          meta: {
            label: i18n.t('system.text_20'),
            permission: 'notices_list',
            t: 'dictionary.notice',
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.notice')) {
                return true
              }
              return store.getters.isSysCE
            },
          },
          component: Layout,
          children: [
            {
              name: 'Notice',
              path: '',
              component: Notice,
            },
          ],
        },
        {
          path: '/companyinfo',
          meta: {
            label: i18n.t('system.text_18'),
            permission: 'infos_list',
            t: 'dictionary.companyinfo',
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.companyinfo')) {
                return true
              }
              return false
            },
          },
          component: Layout,
          children: [
            {
              name: 'CompanyInfo',
              path: '',
              component: CompanyInfo,
            },
          ],
        },
        {
          path: '/endpoint',
          meta: {
            label: i18n.t('system.text_21'),
            permission: 'endpoints_list',
            t: 'dictionary.endpoint',
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.endpoint')) {
                return true
              }
              return store.getters.isSysCE
            },
          },
          component: Layout,
          children: [
            {
              name: 'Endpoint',
              path: '',
              component: Endpoint,
            },
          ],
        },
        {
          path: '/service',
          meta: {
            label: i18n.t('system.system_service'),
            permission: 'services_list',
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.service')) {
                return true
              }
              return !store.getters.isAdminMode
            },
          },
          component: Layout,
          children: [
            {
              name: 'Service',
              path: '',
              component: Service,
            },
          ],
        },
      ],
    },
    {
      meta: {
        label: i18n.t('cloudenv.text_16'),
      },
      subGroup: 'system',
      submenus: [
        {
          path: '/tag',
          meta: {
            label: i18n.t('cloudenv.text_16'),
            permission: 'metadatas_perform_tag_value_pairs',
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.tag')) {
                return true
              }
              if (!(hasServices('image') || hasServices('identity') || hasServices('compute'))) {
                return true
              }
              return store.getters.isSysCE
            },
          },
          component: Layout,
          children: [
            {
              name: 'Tag',
              path: '',
              component: Tag,
            },
          ],
        },
        {
          path: '/pre-defined-tag',
          meta: {
            label: i18n.t('system.pre_defined_tags'),
            permission: 'tags_list',
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.pre_defined_tag')) {
                return true
              }
              return store.getters.isProjectMode
            },
          },
          component: Layout,
          children: [
            {
              name: 'PreDefinedTag',
              path: '',
              component: PreDefinedTag,
            },
          ],
        },
      ],
    },
    {
      meta: {
        label: i18n.t('cloudenv.text_499'),
      },
      subGroup: 'system',
      submenus: [
        {
          path: '/strategyallocation',
          meta: {
            label: i18n.t('cloudenv.text_500'),
            permission: 'scopedpolicybindings_list',
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.strategyallocation')) {
                return true
              }
              return store.getters.isSysCE
            },
          },
          component: Layout,
          children: [
            {
              name: 'Strategyallocation',
              path: '',
              component: Strategyallocation,
            },
          ],
        },
        {
          path: '/strategydefinition',
          meta: {
            label: i18n.t('cloudenv.text_501'),
            permission: 'scopedpolicies_list',
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.strategydefinition')) {
                return true
              }
              return store.getters.isSysCE
            },
          },
          component: Layout,
          children: [
            {
              name: 'Strategydefinition',
              path: '',
              component: Strategydefinition,
            },
            {
              name: 'StrategydefinitionCreate',
              path: 'create',
              component: StrategydefinitionCreate,
            },
          ],
        },
      ],
    },
    {
      meta: {
        label: i18n.t('system.text_22'),
        hidden: () => !store.getters.isAdminMode,
      },
      subGroup: 'system',
      submenus: [
        {
          path: '/dictionarysetting',
          meta: {
            label: i18n.t('system.text_23'),
            permission: 'dictionary_get',
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.dictionarysetting')) {
                return true
              }
              // return !store.getters.isAdminMode || store.getters.setting.language !== 'zh-CN'
              return !store.getters.isAdminMode || store.getters.isSysCE
            },
          },
          component: Layout,
          children: [
            {
              name: 'DictionarySetting',
              path: '',
              component: DictionarySetting,
            },
          ],
        },
        {
          path: '/globalsetting',
          meta: {
            label: i18n.t('system.text_22'),
            permission: 'services_get',
            hidden: () => {
              if (isScopedPolicyMenuHidden('sub_hidden_menus.globalsetting')) {
                return true
              }
              return !store.getters.isAdminMode || store.getters.isSysCE
            },
          },
          component: Layout,
          children: [
            {
              name: 'GlobalSettings',
              path: '',
              component: GlobalSetting,
            },
          ],
        },
      ],
    },
  ],
}
